export default "__VITE_ASSET__f4570f01__"